/* eslint-disable no-useless-catch */
export default function (element: HTMLElement, cssProp: string, expectedCSSUnit: string = 'px'): number {
  if (cssProp.includes('color')) {
    throw new Error('color property is not supported');
  }

  let value = 0;
  const styles = getComputedStyle(element);
  const propValue = styles.getPropertyValue(cssProp);
  const unitLength = expectedCSSUnit.length;

  try {
    value = parseInt(propValue.slice(0, -unitLength), 10);
  } catch (error) {
    throw error;
  }
  return value;
}
